import { render } from "./leave-approval.vue?vue&type=template&id=1c639f5a"
import script from "./leave-approval.vue?vue&type=script&lang=js"
export * from "./leave-approval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__